import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../../store";
import { clearSample, fetchSample } from "../../slices/sample";
import { Box, Button, Typography } from "@mui/material";

interface Props {}

const SampleView: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { sample } = useSelector((store) => store.sample);

  useEffect(() => {
    dispatch(fetchSample());

    return () => {
      dispatch(clearSample());
    };
  }, [dispatch]);

  const handleClick = () => {
    dispatch(fetchSample());
  };

  return (
    <Box>
      <Button onClick={handleClick}>Testing</Button>
      <Typography>{sample?.value}</Typography>
    </Box>
  );
};

export default SampleView;
